// extracted by mini-css-extract-plugin
export default {"faqs":"WK-z","faqContent":"XK-z","faq":"YK-z"};